import * as React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import App from './components/App';
import ScrollToTop from './components/common/ScrollToTop';
import HomePage from './components/home/HomePage';
import BlogPage from './components/blog/BlogPage';
import ArticlePage from './components/blog/ArticlePage';
import DiscoverPage from './components/blog/DiscoverPage';
import DiscoverArticlePage from './components/blog/DiscoverArticlePage';
import Privacy from './components/supporting/Privacy';
import Terms from './components/supporting/Terms';
import CookiePolicy from './components/supporting/CookiePolicy';
import FAQ from './components/supporting/FAQ';
import HowItWorks from './components/supporting/HowItWorks';
import About from './components/supporting/About';
import Announcements from './components/supporting/Announcements';
import LyricVideo from './components/supporting/LyricVideo';
import PromoteYourMusic from './components/supporting/PromoteYourMusic';
import SpinnupDiscountCode from './components/supporting/SpinnupDiscountCode';
import RecommendedLinks from './components/supporting/RecommendedLinks';
import Contact from './components/supporting/Contact';
import ReportSpam from './components/supporting/ReportSpam';
import Landing from './components/supporting/Landing';
import ProfilePage from './components/profile/ProfilePage';
import LoginPage from './components/account/LoginPage';
import SignupPage from './components/account/SignupPage';
import GigDetailPage from './components/gig/GigDetailsPage';
import PrivateRoute from './components/common/PrivateRoute';
import ProfileBrowsePage from './components/profile/browse/ProfileBrowsePage';
import roleTypes from './constants/roleTypes';
import GigBrowsePage from './components/gig/GigBrowsePage';
import TrackPage from './components/additionalPages/TrackPage';
import VideoPage from './components/additionalPages/VideoPage';
import ActivityFeedPage from './components/activityFeed/ActivityFeedPage';
import ChartPage from './components/chart/ChartPage';
import ConfirmEmailPage from './components/account/ConfirmEmailPage';
import CreateProfilePage from './components/profileAdmin/CreateProfilePage';
import NewsFeedPage from './components/newsFeed/NewsFeedPage';
import ManageProfilePage from './components/profileAdmin/ManageProfilePage';
import MessagesPage from './components/message/MessagesPage';
import DiscussionSectionPage from './components/discussion/DiscussionSectionPage';
import DiscussionPage from './components/discussion/DiscussionPage';
import NewDiscussionPage from './components/discussion/NewDiscussionPage';
import PostsPage from './components/discussion/PostsPage';
import AccountSettingsPage from './components/account/AccountSettingsPage';
import CloseAccountPage from './components/account/CloseAccountPage';
import Welcome from './components/supporting/Welcome';
import ForgotPasswordPage from './components/account/ForgotPasswordPage';
import ResetPasswordPage from './components/account/ResetPasswordPage';

export const routes = <ScrollToTop>
    <App>
        <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/Gigs" component={GigBrowsePage} />
            <Route path="/Gigs/:id" component={GigDetailPage} />
            <Route path="/Privacy" component={Privacy} />
            <Route path="/Terms" component={Terms} />
            <Route path="/CookiePolicy" component={CookiePolicy} />
            <Route path="/Faq" component={FAQ} />
            <Route path="/HowItWorks" component={HowItWorks} />
            <Route path="/About" component={About} />
            <Route path="/Announcements" component={Announcements} />
            <Route path="/LyricVideo" component={LyricVideo} />
            <Route path="/PromoteYourMusic" component={PromoteYourMusic} />
            <Route path="/SpinnupDiscountCode" component={SpinnupDiscountCode} />
            <Route path="/RecommendedLinks" component={RecommendedLinks} />
            <Route path="/ActivityFeed" component={ActivityFeedPage} />
            <Route path="/Contact" component={Contact} />
            <Route path="/ReportSpam" component={ReportSpam} />
            <Route path="/Intro" component={Landing} />            
            <Route path="/Account/Signup" component={SignupPage} />
            <Route path="/Account/Login" component={LoginPage} />
            <Route path="/Account/ConfirmEmail" component={ConfirmEmailPage} />
            <Route path="/Account/ForgottenPassword" component={ForgotPasswordPage} />
            <Route path="/Account/ResetPassword" component={ResetPasswordPage} />
            <PrivateRoute path="/Account/Settings" component={AccountSettingsPage} />
            <PrivateRoute path="/Account/Close" component={CloseAccountPage} />
            <Route path="/TrackOfTheWeek">
                <Redirect to="/TrackOfTheMonth" />
            </Route>
            <Route path="/TrackOfTheMonth" component={TrackPage} />
            <Route path="/Track/:id" component={TrackPage} />
            <Route path="/Video/:id" component={VideoPage} />
            <Route path="/Charts/:tabName?" component={ChartPage} />
            <Route exact path="/Blog" component={BlogPage} />
            <Route path="/Blog/:link" component={ArticlePage} />
            <Route exact path="/Unsigned" component={BlogPage} />
            <Route path="/Unsigned/:link" component={ArticlePage} />            
            <Route exact path="/Discover" component={DiscoverPage} />
            <Route path="/Discover/:link" component={DiscoverArticlePage} />
            <PrivateRoute path="/Profile/Create" component={CreateProfilePage} />            
            <PrivateRoute path="/Profile/Manage/:tabName?" requireProfile component={ManageProfilePage} />
            <PrivateRoute path="/Welcome" component={Welcome} requireProfile /> 
            <PrivateRoute path="/Notifications" component={NewsFeedPage} requireProfile />
            <PrivateRoute path="/Messages/:tabName?" component={MessagesPage} requireProfile />
            <Route exact path="/Discussions" component={DiscussionSectionPage} />
            <Route exact path="/Discussions/:sectionLink" component={DiscussionPage} />
            <PrivateRoute exact path="/Discussions/:sectionLink/NewDiscussion" component={NewDiscussionPage} />
            <Route exact path="/Discussions/:sectionLink/:discussionLink" component={PostsPage} />
            {roleTypes.filter(roleType => roleType.public).map(roleType => {
                return <Route key={roleType.type} path={`/${roleType.route}/:genre?/:association?`} component={ProfileBrowsePage}/>;
            })}
            <Route exact path="/:username/:tabName?" component={ProfilePage} />
            {/*<PrivateRoute exact path="/timezones" component={ListTimeZones} />*/}
        </Switch>
    </App>
</ScrollToTop>;
